<template>
    <div class="mt-2" :class="alertClass" v-if="mostraMessaggio">
        <template v-if="fontawesome == 'embedded'">
            <font-awesome-icon :icon="alertIcon" :spin="alertIconSpin" />
        </template>
        <template v-else>
            <i v-if="alertIconSpin" class="fas fa-spinner fa-spin"></i>
            <i v-else :class="'fas ' + alertIcon"></i>
        </template>
        &nbsp; {{ProcessaTestoMessaggio()}}
    </div>
</template>

<script>


export default {
 name: "MessaggioStandard",   
 props: {
    mostraMessaggio: Boolean,
    alertMessaggio: [],
    alertClass: String,     
    alertIcon: String,
    alertIconSpin: Boolean,
    fontawesome: {
        type: String,
        default: "embedded"
    }

 },
 data: function () {
    return {
      
    }
 },
 methods: {
    ProcessaTestoMessaggio() {
    

        let msg = '';
        for(let i=0; i<this.alertMessaggio.length; i++) {
            msg += this.alertMessaggio[i] + " ";
        }
        return msg;
    }    
 },
 watch: {
   
 },
 mounted: function() {
    
    
 }
 
}

</script>

<style scoped>


</style>
